const styles = theme => ({
  title: {
    marginBottom: 32,
  }
})

export default styles
